class MDConvertor {

    convertMdToHtml(text) {

        let convertedText = text;

        convertedText = convertedText.replaceAll ('---', '<hr>');
    
        if(convertedText.indexOf('*') != -1 && convertedText.indexOf('**') != -1) 
        {
            convertedText = convertedText.replaceAll('**', '</b>');
            convertedText = convertedText.replaceAll('*', '<b>');
        }
        
        if(convertedText.indexOf('_') != -1 && convertedText.indexOf('__') != -1) 
        {
            convertedText = convertedText.replaceAll('__', '</i>');
            convertedText = convertedText.replaceAll('_', '<i>');
        }

        return convertedText
    }

    convertHtmlToMd(text) {

        let convertedText = text;

        convertedText = convertedText.replaceAll ('<hr>', '---');
    
        convertedText = convertedText.replaceAll('</b>', '**');
        convertedText = convertedText.replaceAll('<b>', '*');
        
        convertedText = convertedText.replaceAll('</i>', '__');
        convertedText = convertedText.replaceAll('<i>', '_');

        return convertedText;
    }
}